import { ILegalPhaseFullObject } from '../Interfaces/ILegalPhase';
import { ILegalPhaseTemplateFullObject } from '../Interfaces/ILegalPhaseTemplate';
import { ILegalRequirementFullObject } from '../Interfaces/ILegalRequirement';
import { ILegalRequirementTemplateFullObject } from '../Interfaces/ILegalRequirementTemplate';
import { ILegalTransactionTypeFullObject } from '../Interfaces/ILegalTransactionType';

export const getIsEmail = (currentEmail: string | null | undefined) => {
  if (currentEmail === undefined || currentEmail === null) {
    return false;
  } else {
    const splitetByAd = currentEmail.split('@');

    if (splitetByAd.length !== 2) {
      return false;
    }

    const splitetByPoint = splitetByAd[1].split('.');

    return splitetByPoint.length === 2 && splitetByPoint[1].length > 0;
  }
};

export const checkIsUnderTen = (currentValue: number) => {
  if (currentValue < 10) {
    return `0${currentValue}`;
  } else {
    return `${currentValue}`;
  }
};

export const getStringdateFromDate = (dateObject: Date) => {
  const y = dateObject.getFullYear();
  const m = dateObject.getMonth() + 1;
  const d = dateObject.getDate();
  return `${y}-${checkIsUnderTen(m)}-${checkIsUnderTen(d)}`;
};

export const castWithZeroTimezone = (
  targetValue: Date | string | null
): Date => {
  if (targetValue === null) {
    return new Date();
  }

  // Falls targetValue bereits ein Date-Objekt ist, direkt zurückgeben
  if (targetValue instanceof Date) {
    return targetValue;
  }

  // Falls targetValue ein String ist, prüfen und umwandeln
  if (typeof targetValue === 'string') {
    if (targetValue.includes('Z')) {
      return new Date(targetValue);
    } else {
      return new Date(targetValue.replace(' ', 'T') + 'Z');
    }
  }

  // Fallback (sollte nie erreicht werden)
  return new Date();
};

export const getZeroTimezoneStringFromDate = (dataObject: Date) => {
  if (isNaN(dataObject.getTime())) {
    return null;
  }

  const isoString = dataObject.toISOString();

  const returnString = isoString.replace('T', ' ').split('.')[0];

  return `${returnString}`;
};

export const getHfromMinutes = (diffMin: number) => {
  const minutes = diffMin % 60;
  const hours = (diffMin - minutes) / 60;

  return `${checkIsUnderTen(hours)}:${checkIsUnderTen(minutes)} Std.`;
};

export const compageDateFirstOneSmallerEqual = (
  dateOne: Date,
  dateTwo: Date
) => {
  const newDateOne = new Date(dateOne);
  const newDateTwo = new Date(dateTwo);
  //
  newDateOne.setHours(0, 0, 0, 0);
  newDateTwo.setHours(0, 0, 0, 0);

  return newDateOne <= newDateTwo;
};

export const getNewReq = (id: number) => {
  return {
    idLegalPhase: -1,
    idLegalRequirement: id,
    isInterneLegalRequirement: false,
    canUploadFilesClient: false,
    canUploadFilesEmployees: false,
    hasError: false,
    hasErrorFreeText: false,
    LegalRequirement: '',
    sendMail: false,
    sendInternLegalRequirementMail: false,
    isEmailSent: false,
    sendEmailAgain: false,
    EmailBody: null,
    EmailSubject: null,
    Predecessor_idLegalRequirement: null,
    TextOfError: null,
    Position: 0,
    enableError: false,
    enableFreeTextError: false,
    isComplete: false,
    idLegalRequirementState: 10,
    User_idUser: null,
    InfoText: null,
    initialProcessingTime: 14,
    ManualProcessingTime: false,
    UserDeadlineNotified: false,
    DocumentArrayEmployees: [],
  } as ILegalRequirementFullObject;
};

export const getEmptyLegalRequirementTemplateFullObject = () => {
  const tmpObject: ILegalRequirementTemplateFullObject = {
    idLegalPhaseTemplate: null,
    idLegalRequirementTemplate: -1,
    isInterneLegalRequirement: false,
    canUploadFilesClient: false,
    canUploadFilesEmployees: false,
    hasError: false,
    hasErrorFreeText: false,
    LegalRequirementTemplate: '',
    sendMail: false,
    EmailBody: '<p></p>\n',
    EmailSubject: '',
    Predecessor_idLegalRequirementTemplate: null,
    TextOfError: null,
    Position: 0,
    idLegalRequirementState: 10,
    idUser: null,
    isTemplate: true,
    InfoText: null,
    //Deadline: undefined,
    DeadlineArray: [],
    initialProcessingTime: 14,
    currentProcessingTime: null,
    idCourt: null,
    idCourtRole: null,
    Court: null,
    CourtRole: null,
    DocumentArray: [],
  };
  return tmpObject;
};

export const getEmptyReq = (currentPhase: ILegalPhaseFullObject) => {
  let tmpId = -1;

  if (currentPhase.LegalRequirementArray.length > 0) {
    const tmpIdArry = Math.min(
      ...currentPhase.LegalRequirementArray.map(x => x.idLegalRequirement)
    );

    if (tmpIdArry <= tmpId) {
      tmpId = tmpIdArry - 1;
    }
  }

  //const tmpObject = { ...currentPhase };
  const tmpObject: ILegalRequirementFullObject = {
    idLegalPhase: -1,
    idLegalRequirement: tmpId,
    isInterneLegalRequirement: false,
    canUploadFilesClient: false,
    canUploadFilesEmployees: false,
    hasError: false,
    //hasErrorFreeText: false,
    LegalRequirement: '',
    sendMail: false,
    sendInternLegalRequirementMail: false,
    isEmailSent: false,
    sendEmailAgain: false,
    EmailBody: '<p></p>\n',
    EmailSubject: '',
    //Predecessor_idLegalRequirement: null,
    TextOfError: null,
    Position:
      currentPhase.LegalRequirementArray.length === 0
        ? 1
        : Math.max(...currentPhase.LegalRequirementArray.map(x => x.Position)) +
          1,
    enableError: false,
    enableFreeTextError: false,
    isComplete: false,
    idLegalRequirementState: 10,
    User_idUser: null,
    InfoText: null,
    initialProcessingTime: 14,
    ManualProcessingTime: false,
    UserDeadlineNotified: false,
  };

  return tmpObject;
};

export const getNewPhase = (legalPhaseArrayx: ILegalPhaseFullObject[]) => {
  let tmpId = Math.min(...legalPhaseArrayx.map(x => x.idLegalPhase)) - 1;

  if (tmpId >= 0) {
    tmpId = -1;
  }

  return {
    idLegalPhase: tmpId,
    InfoText: null,
    isComplete: false,
    LegalPhase: '',
    LegalRequirementArray: [],
    Position: Math.max(...legalPhaseArrayx.map(x => x.Position)) + 1,
    PreconditionArray: [],
    idAdministrativeUnit: null,
    AdministrativeUnit: null,
  } as ILegalPhaseFullObject;
};

export const getEmptyReqTemplate = (
  currentPhase: ILegalPhaseTemplateFullObject
) => {
  let tmpId = -1;

  if (currentPhase.LegalRequirementArray.length > 0) {
    const tmpIdArry = Math.min(
      ...currentPhase.LegalRequirementArray.map(
        x => x.idLegalRequirementTemplate
      )
    );

    if (tmpIdArry <= tmpId) {
      tmpId = tmpIdArry - 1;
    }
  }

  //const tmpObject = { ...currentPhase };
  const tmpObject: ILegalRequirementTemplateFullObject = {
    idLegalPhaseTemplate: -1,
    idLegalRequirementTemplate: tmpId,
    isInterneLegalRequirement: false,
    canUploadFilesClient: false,
    canUploadFilesEmployees: false,
    hasError: false,
    hasErrorFreeText: false,
    LegalRequirementTemplate: '',
    sendMail: false,
    EmailBody: '<p></p>\n',
    EmailSubject: '',
    Predecessor_idLegalRequirementTemplate: null,
    TextOfError: null,
    Position:
      currentPhase.LegalRequirementArray.length === 0
        ? 1
        : Math.max(...currentPhase.LegalRequirementArray.map(x => x.Position)) +
          1,
    idLegalRequirementState: 10,
    idUser: null,
    isTemplate: false,
    InfoText: null,
    //Deadline: undefined,
    DeadlineArray: [],
    initialProcessingTime: 14,
    currentProcessingTime: null,
    idCourt: null,
    idCourtRole: null,
    Court: null,
    CourtRole: null,
    DocumentArray: [],
  };
  return tmpObject;
};

export const getEmptyLegalTransactionTypeFullObject = () => {
  return {
    idLegalTransactionType: -1,
    idArnoTopObject: null,
    LegalTransactionType: '',
    LegalPhaseTemplateArray: [],
    LegalRoleTemplateArray: [],
    LegalRoleTemplateCanInviteArray: [],
    isTemplate: false,
    withDialog: false,
    DocumentDirectoryTemplateArray: [],
    DocumentArray: [],
    MeetingEmailTemplateArray: [],
  } as ILegalTransactionTypeFullObject;
};

export const getEmptyLegalPhaseTemplateFullObject = (
  localArray: ILegalPhaseTemplateFullObject[]
) => {
  let tmpId = -1;

  if (localArray.length > 0) {
    const tmpIdArray = Math.min(...localArray.map(x => x.idLegalPhaseTemplate));

    if (tmpIdArray <= tmpId) {
      tmpId = tmpIdArray - 1;
    }
  }

  return {
    idLegalPhaseTemplate: tmpId,
    idLegalTransactionType: -1,
    LegalPhaseTemplate: '',
    LegalRequirementArray: [],
    //Position: localArray.length,
    Position:
      localArray.length === 0
        ? 1
        : Math.max(...localArray.map(x => x.Position)) + 1,
    PreconditionArray: [],
    InfoText: null,
    idAdminstrativeUnit: null,
  } as ILegalPhaseTemplateFullObject;
};
